export const navigation = {
    previous: "previous",
    next: "next",
    up: "up",
    down: "down"
};